import { ExternalLink } from '@/redux/services/externalLinksApi'
import { ArticlesCard } from '@/types'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
    item: ExternalLink
}

const OurArticlesCard: React.FC<Props> = ({ item }) => {
    const {t} = useTranslation()

    return (
        <div draggable className='our-articles__card'>
            <p
                style={!item.title ? { marginBottom: 24 } : {}}
                className='our-articles__card-tag megaschool__card-tag categories-slider__text'
            >
                {t('externalLinks')}
            </p>
            {item.title && <h3 className='our-articles__card-title megaschool__card-title'>{item.title}</h3>}
            {item.description && <p className='our-articles__card-text megaschool__info-text'>{item.description}</p>}
            <div
                style={item.title ? { gap: '32px' } : { gap: '36px' }}
                className='our-articles__card-links'
            >
                {item.cards?.map(item => (
                    <Link
                        key={item.link}
                        href={item.link}
                        className='our-articles__card-link'
                    >
                        <div className='our-articles__card-wrapper'>
                            <div className="our-articles__image-wrapper">
                                <Image
                                    className='our-articles__image'
                                    src={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${item.image}`}
                                    alt=''
                                    width={32}
                                    height={32}
                                    objectFit='contain'
                                />
                            </div>
                            <p>{item.text}</p>
                        </div>
                        <svg
                            style={{ flexShrink: 0 }}
                            width='8'
                            height='8'
                            viewBox='0 0 8 8'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M7.25685 0.999884C7.25685 0.668513 6.98823 0.399884 6.65685 0.399884L1.25685 0.399884C0.925483 0.399884 0.656854 0.668513 0.656854 0.999884C0.656854 1.33125 0.925483 1.59988 1.25685 1.59988L6.05685 1.59988L6.05685 6.39988C6.05685 6.73125 6.32548 6.99988 6.65685 6.99988C6.98823 6.99988 7.25685 6.73125 7.25685 6.39988L7.25685 0.999884ZM0.575736 6.23247C0.341421 6.46679 0.341421 6.84669 0.575736 7.081C0.810051 7.31532 1.18995 7.31532 1.42426 7.081L0.575736 6.23247ZM1.42426 7.081L7.08112 1.42415L6.23259 0.57562L0.575736 6.23247L1.42426 7.081Z'
                                fill='#6689DA'
                            />
                        </svg>
                    </Link>
                ))}
            </div>
        </div>
    )
}

export default OurArticlesCard
